import { graphql, useFragment } from 'react-relay';

import { getChargeIsPixInstallment } from '@woovi/shared';

import type { PaymentInstallmentPlan_charge$key } from './__generated__/PaymentInstallmentPlan_charge.graphql.ts';
import PaymentInstallments from './PaymentInstallments.tsx';

import type { ReactNode } from 'react';

type PaymentInstallmentPlanProps = {
  charge: PaymentInstallmentPlan_charge$key;
};
const PaymentInstallmentPlan = (
  props: PaymentInstallmentPlanProps,
): ReactNode => {
  const charge = useFragment<PaymentInstallmentPlan_charge$key>(
    graphql`
      fragment PaymentInstallmentPlan_charge on Charge {
        chargeIntent {
          id
        }
        paymentMethods {
          ... on PaymentMethodInstallments {
            method
          }
        }
        ...PaymentInstallments_charge
      }
    `,
    props.charge,
  );

  const isChargePixCobFromInstallment = charge?.chargeIntent?.id;
  const isChargeInstallment = getChargeIsPixInstallment(charge);

  if (!isChargeInstallment && !isChargePixCobFromInstallment) {
    return null;
  }

  return <PaymentInstallments charge={charge} />;
};

export default PaymentInstallmentPlan;
